var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareLotLogo = function SvgShareLotLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84 13.811a1.69 1.69 0 0 0 0 2.383l2.4 2.396 2.398-2.396a1.688 1.688 0 0 0 0-2.383l-2.396-2.393-2.402 2.393ZM16.998 5.507l-.006-.007L12.236.75l-9.531 9.516c-2.607 2.603-2.607 6.862 0 9.464l.024.024 14.27-14.247Z",
    fill: "#14B97E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.066 16.578a2.233 2.233 0 0 1 0-3.152l-6.337 6.329L6.9 23.92l4.762-4.756c-.018-.014-2.596-2.587-2.596-2.587Z",
    fill: "url(#share_lot_logo_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.579 6.086-4.76 4.754c.016.014 2.593 2.586 2.593 2.586a2.233 2.233 0 0 1 0 3.152l6.336-6.328-4.17-4.164Z",
    fill: "url(#share_lot_logo_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.748 10.25 7.48 24.5l4.756 4.75 9.527-9.52c2.607-2.603 2.607-6.862 0-9.464l-.015-.016Z",
    fill: "#14B97E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "share_lot_logo_svg__a",
    x1: 10,
    y1: 20.689,
    x2: 6.093,
    y2: 16.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12B97E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008B51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "share_lot_logo_svg__b",
    x1: 14.294,
    y1: 9.133,
    x2: 18.59,
    y2: 13.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12B97E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008B51"
  })))));
};
export default SvgShareLotLogo;